import React from "react";

const FileAlertIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#444"
        d="M13.06 3.133 16 5.932V18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8.03l3.03 3.133ZM7.648 14.76a1.12 1.12 0 0 0-1.132 1.108 1.12 1.12 0 0 0 1.132 1.109 1.12 1.12 0 0 0 1.133-1.109 1.12 1.12 0 0 0-1.133-1.108ZM6.516 7v6.651H8.78V7H6.516Zm3.632.625h4.665L12.13 5.069l-1.983-1.99v4.546Z"
      />
    </svg>
  );
};

export default FileAlertIcon;
